<app-ace-select
  [bindValue]="bindToMetadataId ? METADATA_ID_KEY : null"
  [bindLabel]="bindLabel"
  [formControl]="formControl"
  [loading]="loading"
  [items]="metadata"
  [placeholder]="'Select Metadata' | messageTranslate"
  [multiSelect]="multiSelect"
  [groupBy]="groupBy"
  [maxSelectedLabels]="maxSelectedLabels"
  [showClearItem]="showClearItem"
  [truncateLabels]="truncateLabels"
  [searchFn]="searchFn"
  [virtualScroll]="virtualScroll"
  [appendTo]="appendTo"
  (touched)="onTouched()">
  <ng-template #optionTemplate let-item="item">
    <ng-template [ngTemplateOutlet]="metadataLabelTemplate"
                 [ngTemplateOutletContext]="{metadata: item}"/>
  </ng-template>
  @if (!bindLabel) {
    <ng-template #labelTemplate let-item="item">
      <ng-template [ngTemplateOutlet]="metadataLabelTemplate"
                   [ngTemplateOutletContext]="{metadata: item}"/>
    </ng-template>
  }
  <ng-template #metadataLabelTemplate let-metadata="metadata">
    <div class="ng-value-label" [title]="metadata.name + ' (' + metadata.code + '): ' + metadata.unit?.unit">
      {{ metadata.name }} ({{metadata.code}}): {{ metadata.unit?.unit }}</div>
  </ng-template>

</app-ace-select>


